module.exports = __webpack_public_path__ + "assets/images/animations/creando-animation.webp?e7120ea1";